import type { RouteLocationRaw } from 'vue-router'
import type { Notification } from './types.ts'

/** Derives a notification's destination from its `type`, offered only when `ledgerId` matches the active ledger. */
export function notificationTarget(
  notification: Notification,
  activeLedgerId: string | undefined,
): RouteLocationRaw | undefined {
  switch (notification.type) {
    case 'EXPORT_READY':
    case 'EXPORT_FAILED':
      return notification.ledgerId !== undefined && notification.ledgerId === activeLedgerId
        ? { name: 'exports' }
        : undefined
    default:
      return undefined
  }
}
